import RachelSparkIcon from './RachelSparkIcon';

interface RachelSparkActionIconProps {
  size?: number;
}

const RachelSparkActionIcon = ({ size }: RachelSparkActionIconProps) => (
  <RachelSparkIcon size={size} strokeOpacity={1} />
);

export default RachelSparkActionIcon;
